module.exports = __webpack_public_path__ + "static/img/6.51f657c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/6.png
// module id = 0TjR
// module chunks = 0